/**
 * Service pour gérer les préférences utilisateur
 * Sauvegarde et récupère les préférences du configurateur Material UI
 */

// URL de l'API
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (process.env.NODE_ENV === 'production') {
    return window.location.origin + '/api';
  }
  return '/api';
};

const API_BASE_URL = getApiBaseUrl();

/**
 * Sauvegarde les préférences UI de l'utilisateur dans MongoDB
 * @param {string} email - Email de l'utilisateur
 * @param {object} preferences - Les préférences à sauvegarder
 * @returns {Promise<object>} - Résultat de la sauvegarde
 */
export const saveUserPreferences = async (email, preferences) => {
  try {
    console.log('💾 Sauvegarde des préférences UI pour:', email);

    const response = await fetch(`${API_BASE_URL}/preferences/save`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        preferences: preferences,
      }),
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la sauvegarde des préférences');
    }

    const result = await response.json();
    console.log('✅ Préférences sauvegardées avec succès');
    return { success: true, data: result };
  } catch (error) {
    console.error('❌ Erreur lors de la sauvegarde des préférences:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Récupère les préférences UI de l'utilisateur depuis MongoDB
 * @param {string} email - Email de l'utilisateur
 * @returns {Promise<object>} - Les préférences de l'utilisateur
 */
export const getUserPreferences = async (email) => {
  try {
    console.log('📦 Récupération des préférences UI pour:', email);

    const response = await fetch(`${API_BASE_URL}/preferences/get`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email }),
    });

    if (!response.ok) {
      console.log('⚠️ Pas de préférences sauvegardées');
      return null;
    }

    const result = await response.json();

    if (result.success && result.preferences) {
      console.log('✅ Préférences récupérées:', result.preferences);
      return result.preferences;
    }

    return null;
  } catch (error) {
    console.error('❌ Erreur lors de la récupération des préférences:', error);
    return null;
  }
};

export default {
  saveUserPreferences,
  getUserPreferences,
};
